import React, { useLayoutEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Avatar } from '@material-ui/core';
import {
  usePopupState,
  bindHover,
} from 'material-ui-popup-state/hooks';
import { Link } from 'react-router-dom';
import Routes from 'Routes';
import SpeakerItemPopover from './SpeakerItemPopover';

const RootContainer = styled.div`
  flex: 1 0 auto;
  display: flex;
  width: 250px;
  align-items: center;
  margin-right: 40px;
  padding: 16px 0 0;
  cursor: pointer;
  overflow: hidden;
`;

const ProfileContainer = styled.div`
  margin-left: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 58px;
  overflow: hidden;
  flex: 1 1 auto;
  width: 0;
`;

const NameContainer = styled.div`
  white-space: nowrap;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 18px;
  color: #484848;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const CompanyTitleContainer = styled.div`
  white-space: nowrap;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.5);
  text-overflow: ellipsis;
  overflow: hidden;
`;

const StyledAvatar = styled(Avatar)`
  width: 48px;
  height: 48px;
`;

const StyledLink = styled(Link)`
  text-decoration: none;
`;

// Recursively checks if all children are overflowing
const isOverflowing = (element) => {
  if (element?.children?.length) {
    const isChildrenOverflowing = Array.from(element.children).map((el) => isOverflowing(el));
    return isChildrenOverflowing.some((isOverflow) => isOverflow);
  }
  return element?.offsetHeight < element?.scrollHeight
    || element?.offsetWidth < element?.scrollWidth;
};

const SpeakerItem = ({
  name, company, title, avatar, id, webinarId,
}) => {
  const [popoverEnabled, setPopoverEnabled] = useState(false);
  const profileRef = useRef();
  const popupState = usePopupState({
    variant: 'popover',
    popupId: `popover-${id}`,
  });
  useLayoutEffect(() => {
    if (profileRef.current) {
      setPopoverEnabled(isOverflowing(profileRef.current));
    }
  }, []);
  return (
    <StyledLink to={Routes.webinarSpeaker(webinarId, id)}>
      <RootContainer {...bindHover(popupState)}>
        <StyledAvatar alt={name} src={avatar} />
        <ProfileContainer ref={profileRef}>
          {name && <NameContainer>{ name }</NameContainer>}
          {company && <CompanyTitleContainer className="SpeakerItemCompanyTitleContainer">{ company }</CompanyTitleContainer>}
          {title && <CompanyTitleContainer className="SpeakerItemCompanyTitleContainer">{ title }</CompanyTitleContainer>}
        </ProfileContainer>
      </RootContainer>
      {popoverEnabled && <SpeakerItemPopover popupState={popupState} name={name} company={company} title={title} />}
    </StyledLink>
  );
};

SpeakerItem.propTypes = {
  name: PropTypes.string,
  company: PropTypes.string,
  title: PropTypes.string,
  avatar: PropTypes.string,
  id: PropTypes.number.isRequired,
  webinarId: PropTypes.number.isRequired,
};

SpeakerItem.defaultProps = {
  name: '',
  company: '',
  title: '',
  avatar: '',
};

export default SpeakerItem;
